// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import React from 'react';

type SvgProps = {
    width?: number;
    height?: number;
}

const DataRetentionSVG = (props: SvgProps) => (
    <svg
        width={props.width ? props.width.toString() : '142'}
        height={props.height ? props.height.toString() : '104'}
        viewBox='0 0 142 104'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            d='M5.50196 18L5.50195 33L94.002 33'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.32'
            strokeLinecap='round'
        />
        <path
            d='M4.002 90L14.5019 79.5L14.502 40.5L35.5019 40.5'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.32'
            strokeLinecap='round'
        />
        <path
            d='M133.502 52L133.502 66L46.002 66'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.32'
            strokeLinecap='round'
        />
        <circle
            cx='2.5'
            cy='2.5'
            r='2.5'
            transform='matrix(1 8.74228e-08 8.74228e-08 -1 3.00195 18)'
            fill='var(--center-channel-color)'
            fillOpacity='0.48'
        />
        <circle
            cx='2.5'
            cy='2.5'
            r='2.5'
            transform='matrix(-1 -1.74846e-07 -1.74846e-07 1 136.002 48.5)'
            fill='var(--center-channel-color)'
            fillOpacity='0.48'
        />
        <circle
            cx='2.50195'
            cy='91.5'
            r='2.5'
            fill='var(--center-channel-color)'
            fillOpacity='0.48'
        />
        <rect
            x='11'
            y='14'
            width='94'
            height='40'
            rx='3.75'
            fill='#1C58D9'
            fillOpacity='0.12'
        />
        <rect
            x='37'
            y='57'
            width='105'
            height='37'
            rx='3.75'
            fill='#1C58D9'
            fillOpacity='0.12'
        />
        <rect
            x='33.3885'
            y='8.15259'
            width='50.505'
            height='65.3594'
            rx='2'
            transform='rotate(-8.6173 33.3885 8.15259)'
            fill='var(--center-channel-bg)'
        />
        <rect
            x='33.9578'
            y='8.57203'
            width='49.505'
            height='64.3594'
            rx='1.5'
            transform='rotate(-8.6173 33.9578 8.57203)'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.8'
        />
        <path
            d='M40.3696 14.1746L48.8912 12.8832'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.48'
            strokeLinecap='round'
        />
        <path
            d='M46.8125 56.6891L74.5075 52.4921'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.48'
            strokeLinecap='round'
        />
        <path
            d='M44.4152 40.8698L72.1101 36.6727'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.48'
            strokeLinecap='round'
        />
        <path
            d='M40.969 18.1294L56.5918 15.7618'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.48'
            strokeLinecap='round'
        />
        <path
            d='M48.0112 64.5989L84.2277 59.1105'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.48'
            strokeLinecap='round'
        />
        <path
            d='M45.6138 48.7794L81.8303 43.291'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.48'
            strokeLinecap='round'
        />
        <path
            d='M43.2165 32.9601L79.433 27.4717'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.48'
            strokeLinecap='round'
        />
        <path
            d='M41.5683 22.0842L47.9595 21.1157'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.48'
            strokeLinecap='round'
        />
        <path
            d='M50.4667 20.7357L56.8579 19.7672'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.48'
            strokeLinecap='round'
        />
        <path
            d='M36.2393 36.6232C36.4201 35.6811 37.2442 35 38.2035 35H127.58C128.836 35 129.781 36.1436 129.544 37.3768L119.761 88.3768C119.58 89.3189 118.756 90 117.796 90H28.4201C27.1645 90 26.2194 88.8564 26.4559 87.6232L36.2393 36.6232Z'
            fill='var(--center-channel-bg)'
        />
        <path
            d='M36.2393 36.6232C36.4201 35.6811 37.2442 35 38.2035 35H127.58C128.836 35 129.781 36.1436 129.544 37.3768L119.761 88.3768C119.58 89.3189 118.756 90 117.796 90H28.4201C27.1645 90 26.2194 88.8564 26.4559 87.6232L36.2393 36.6232Z'
            fill='var(--center-channel-color)'
            fillOpacity='0.56'
        />
        <path
            d='M36.7304 36.7174C36.8659 36.0108 37.4841 35.5 38.2035 35.5H127.58C128.522 35.5 129.23 36.3577 129.053 37.2826L119.27 88.2826C119.134 88.9892 118.516 89.5 117.796 89.5H28.4201C27.4784 89.5 26.7696 88.6423 26.947 87.7174L36.7304 36.7174Z'
            stroke='var(--center-channel-color)'
        />
        <rect
            x='72.5056'
            y='8.99988'
            width='50.505'
            height='65.3594'
            rx='2'
            transform='rotate(7.47748 72.5056 8.99988)'
            fill='var(--center-channel-color)'
            fillOpacity='0.24'
        />
        <rect
            x='75.5056'
            y='7'
            width='50.505'
            height='65.3594'
            rx='2'
            transform='rotate(7.47748 75.5056 7)'
            fill='var(--center-channel-bg)'
        />
        <rect
            x='75.9363'
            y='7.56082'
            width='49.505'
            height='64.3594'
            rx='1.5'
            transform='rotate(7.47748 75.9363 7.56082)'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.8'
        />
        <path
            d='M80.5437 14.7212L89.0892 15.8428'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.48'
            strokeLinecap='round'
        />
        <path
            d='M74.9478 57.3556L102.721 61.0009'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.48'
            strokeLinecap='round'
        />
        <path
            d='M77.03 41.4917L104.803 45.137'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.48'
            strokeLinecap='round'
        />
        <path
            d='M80.0231 18.6873L95.6899 20.7436'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.48'
            strokeLinecap='round'
        />
        <path
            d='M73.9067 65.2876L110.225 70.0545'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.48'
            strokeLinecap='round'
        />
        <path
            d='M75.9889 49.4236L112.307 54.1905'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.48'
            strokeLinecap='round'
        />
        <path
            d='M78.0711 33.5597L114.39 38.3266'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.48'
            strokeLinecap='round'
        />
        <path
            d='M79.5026 22.6532L85.9117 23.4944'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.48'
            strokeLinecap='round'
        />
        <path
            d='M88.426 23.8245L94.8352 24.6657'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.48'
            strokeLinecap='round'
        />
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M35 23C33.8954 23 33 23.8954 33 25V28H28C26.8954 28 26 28.8954 26 30V88C26 89.1046 26.8954 90 28 90H117C118.105 90 119 89.1046 119 88V30C119 28.8954 118.105 28 117 28H65V25C65 23.8954 64.1046 23 63 23H35Z'
            fill='var(--center-channel-bg)'
        />
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M35 23C33.8954 23 33 23.8954 33 25V28H28C26.8954 28 26 28.8954 26 30V88C26 89.1046 26.8954 90 28 90H117C118.105 90 119 89.1046 119 88V30C119 28.8954 118.105 28 117 28H65V25C65 23.8954 64.1046 23 63 23H35Z'
            fill='var(--center-channel-color)'
            fillOpacity='0.12'
        />
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            stroke='var(--center-channel-color)'
            d='M35 23C33.8954 23 33 23.8954 33 25V28H28C26.8954 28 26 28.8954 26 30V88C26 89.1046 26.8954 90 28 90H117C118.105 90 119 89.1046 119 88V30C119 28.8954 118.105 28 117 28H65V25C65 23.8954 64.1046 23 63 23H35Z'
        />
        <path
            opacity='0.32'
            d='M32.1407 103.389C26.137 103.269 21.158 101.213 17.2037 97.2224C13.2495 93.2314 11.1816 88.2605 11 82.3095C11.1785 76.3555 13.2464 71.383 17.2037 67.392C21.1611 63.4011 26.1401 61.3455 32.1407 61.2253C38.0859 61.3486 43.0357 63.4042 46.9899 67.392C50.9442 71.3799 53.0121 76.3524 53.1937 82.3095C53.009 88.2636 50.9411 93.2345 46.9899 97.2224C43.0387 101.21 38.089 103.266 32.1407 103.389Z'
            fill='var(--center-channel-color)'
            fillOpacity='0.32'
        />
        <path
            d='M32.9469 99.6636C27.0678 99.5437 22.2191 97.5347 18.3653 93.6451C14.5091 89.7532 12.4876 84.9101 12.3066 79.084C12.4845 73.255 14.506 68.4106 18.3651 64.5187C22.2222 60.629 27.0709 58.62 32.9469 58.5001C38.7662 58.623 43.5863 60.6311 47.4412 64.5187C51.2971 68.4074 53.3187 73.2518 53.4998 79.084C53.3157 84.9133 51.2941 89.7564 47.4411 93.6451C43.5894 97.5326 38.7694 99.5407 32.9469 99.6636Z'
            fill='var(--center-channel-bg)'
            stroke='var(--center-channel-color)'
        />
        <path
            d='M32.8048 95.0918C28.2155 94.9998 24.4094 93.4274 21.3867 90.3745C18.364 87.3216 16.7832 83.5189 16.6444 78.9667C16.7808 74.412 18.3616 70.6082 21.3867 67.5553C24.4118 64.5024 28.2178 62.93 32.8048 62.838C37.3495 62.9323 41.1332 64.5047 44.1559 67.5553C47.1786 70.6059 48.7594 74.4097 48.8982 78.9667C48.757 83.5213 47.1763 87.3239 44.1559 90.3745C41.1355 93.425 37.3518 94.9975 32.8048 95.0918Z'
            fill='var(--center-channel-bg)'
        />
        <path
            d='M32.8046 94.5917C28.34 94.5 24.6643 92.9742 21.742 90.0227C18.8173 87.0688 17.2829 83.394 17.1446 78.9665C17.2806 74.5369 18.815 70.8611 21.7418 67.9072C24.6667 64.9555 28.3425 63.4298 32.8046 63.3381C37.2233 63.432 40.8774 64.9569 43.8007 67.9072C46.7252 70.8586 48.2597 74.5344 48.3979 78.9666C48.2574 83.3965 46.7228 87.0712 43.8006 90.0227C40.8797 92.9728 37.2257 94.4978 32.8046 94.5917Z'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.32'
        />
        <path
            d='M32.7713 61.6285V78.9649L40.4316 86.6252'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.8'
            strokeLinejoin='round'
        />
        <circle
            cx='32.7713'
            cy='78.965'
            r='1.61269'
            fill='var(--center-channel-color)'
            fillOpacity='0.8'
        />
    </svg>
);

export default DataRetentionSVG;
